import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AnyObject, ErrorMessage } from '@mri/types';

@Component({
  selector: 'app-field-password-verify',
  templateUrl: './field-password-verify.component.html',
  styleUrl: './field-password-verify.component.scss'
})
export class FieldPasswordVerifyComponent {

  private _classSet: Set<string> = new Set<string>();

  @Output() valueChange = new EventEmitter<string>;
  @Input() placeholder?: string;
  @Input() value?: string;
  @Input() label: string;
  @Input() errors?: Array<ErrorMessage>;
  @Input() image?: string | ((value: string) => string);

  get classes(): string {
    return [...this._classSet].join(' ');
  }

  onChange(event: AnyObject){
    this.valueChange.emit(event.target.value)
  }

  onFocus(){
    this._classSet.add('card-focus');
  }

  onBlur(){
    this._classSet.delete('card-focus');
  }
}
